module.exports = __webpack_public_path__ + "static/aime_duplicates-16e404193bc919478421fa7165580acc.png";